import { createReducer, on } from '@ngrx/store';
import * as SensorsActions from './sensors.actions';
import { SensorModel } from '@models/sensor.model';

export interface SensorsState {
  vendorLoading: { [vendor in SensorModel.Provider]?: boolean };
  vendorSensors: {
    [SensorModel.Provider.HALO]?: SensorModel.Halo.SensorMetadataBase[];
    [SensorModel.Provider.DISRUPTIVE]?: SensorModel.Disruptive.SensorMetadataBase[];
  };
  currentSensor: SensorModel.Sensor;
  loading: boolean;
  saving: boolean;
  error: string;
  isDeleting: boolean;
  canDeactivate: boolean;
}

export const initialSensorsState: SensorsState = {
  vendorLoading: {},
  vendorSensors: {},
  currentSensor: undefined,
  loading: false,
  saving: false,
  error: undefined,
  isDeleting: false,
  canDeactivate: false,
};

export const sensorsReducer = createReducer(
  initialSensorsState,
  on(SensorsActions.loadVendorSensors, (state, { vendor }) => ({
    ...state,
    vendorLoading: { ...state.vendorLoading, [vendor]: true },
    error: undefined,
  })),
  on(SensorsActions.loadVendorSensorsSuccess, (state, { vendor, sensors }) => ({
    ...state,
    vendorLoading: { ...state.vendorLoading, [vendor]: false },
    vendorSensors: { ...state.vendorSensors, [vendor]: sensors as any },
  })),
  on(SensorsActions.loadVendorSensorsFail, (state, { vendor, error }) => ({
    ...state,
    vendorLoading: { ...state.vendorLoading, [vendor]: false },
    error,
  })),

  on(SensorsActions.loadSensorById, (state) => ({ ...state, loading: true, error: undefined })),
  on(SensorsActions.loadSensorByIdSuccess, (state, { sensor }) => ({ ...state, loading: false, currentSensor: sensor })),
  on(SensorsActions.loadSensorByIdFail, (state, { error }) => ({ ...state, loading: false, error })),

  on(SensorsActions.resetCurrentSensor, (state) => ({ ...state, currentSensor: undefined })),

  on(SensorsActions.upsertSensor, (state) => ({ ...state, saving: true, error: undefined })),
  on(SensorsActions.upsertSensorSuccess, (state) => ({ ...state, saving: false })),
  on(SensorsActions.upsertSensorFail, (state, { error }) => ({ ...state, saving: false, error })),

  on(SensorsActions.loadSensorById, (state) => ({ ...state, loading: true, error: undefined })),
  on(SensorsActions.loadSensorByIdSuccess, (state) => ({ ...state, loading: false })),
  on(SensorsActions.loadSensorByIdFail, (state, { error }) => ({ ...state, loading: false, error })),

  on(SensorsActions.createSensor, (state) => ({ ...state, saving: true, error: undefined })),
  on(SensorsActions.createSensorSuccess, (state) => ({ ...state, saving: false })),
  on(SensorsActions.createSensorFail, (state, { error }) => ({ ...state, saving: false, error })),

  on(SensorsActions.deleteSensors, (state) => ({ ...state, isDeleting: true, })),
  on(SensorsActions.deleteSensorsSuccess, (state) => ({ ...state, isDeleting: false })),
  on(SensorsActions.deleteSensorsFail, (state) => ({ ...state, isDeleting: false })),

  on(SensorsActions.setCanDeactivate, (state, { canDeactivate }) => ({ ...state, canDeactivate })),
);

export const SensorsFeatureKey = 'sensorsState';


